import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=35fe15fe&scoped=true&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=35fe15fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe15fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fe15fe')) {
      api.createRecord('35fe15fe', component.options)
    } else {
      api.reload('35fe15fe', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=35fe15fe&scoped=true&", function () {
      api.rerender('35fe15fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FormEdit.vue"
export default component.exports